import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Collapse, Form, FormGroup, Row,} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    deleteErrorMsg,
    deleteMsg,
    error,
    LIST,
    NO,
    warning,
    YES,
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {confirmAlert} from "react-confirm-alert";
import {utilHelper} from "../../../jwt/_helpers";
import {
    ButtonClean,
    ButtonSearch,
    ButtonTableDelete,
    ButtonTableFilter
} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";
import BootstrapTable from "react-bootstrap-table-next";
import Select, {makeAnimated} from "react-select";
import {useForm} from "react-hook-form";
import {benefitProvider} from "../../../providers/benefitProvider";
import {promotionBenefitService} from "../../../jwt/_services/relations/promotionBenefitService";

export const PromotionBenefitList = forwardRef((props, ref) => {

    const animatedComponents = makeAnimated();

    const [promotion] = useState(props.promotion);

    const [collapsed, setCollapsed] = useState(false);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const [benefitOptions, setBenefitOptions] = useState([]);
    const [benefit, setBenefit] = useState(undefined);

    useEffect(() => {
        setLoading(true);
        benefitProvider.getOptions()
            .then(result => {
                if (result){
                    setBenefitOptions(result);
                }
                else{
                    setBenefitOptions([]);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setBenefitOptions([]);
                showToastCustom(error, errorMessage);
            });

        const dataRequest = {
            promotion: {id: promotion?.id},
            benefit: {id: null}
        };

        refreshDataList(dataRequest);
    }, []);

    const handleTableChange = () => {
        const dataRequest = {
            promotion: {id: promotion?.id},
            benefit: {id: (benefit?.id ? benefit.id : null)}
        };

        refreshDataList(dataRequest);
    };

    const refreshDataList = (dataRequest) => {
        setLoading(true);
        setListItems([]);

        promotionBenefitService.search(dataRequest)
            .then(result => {
                    setLoading(false);
                    if (result){
                        setListItems(mapResult(result));
                    }else {
                        setListItems([]);
                    }
                })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                showToastCustom(error, errorMessage);
            });
    }

    const mapResult = (result) => {
        let mappedList = [];

        result.map((promoBenefit) => {
            const item = {
                id: promoBenefit.id,
                code: promoBenefit.benefit?.code ? promoBenefit.benefit?.code : "",
                showOrder: promoBenefit.showOrder
            }

            mappedList.push(item);
        });

        return mappedList;
    }

    useImperativeHandle(ref, () => ({
        refreshList() {
            const dataRequest = {
                promotion: {id: promotion?.id},
                benefit: {id: (benefit?.id ? benefit.id : null)}
            };

            refreshDataList(dataRequest);
        }
    }));

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {handleSubmit, reset} = useForm({});

    const onSubmit = (data, _) => {
        const dataRequest = {
            promotion: {id: promotion?.id},
            benefit: {id: (benefit?.id ? benefit.id : null)}
        };

        refreshDataList(dataRequest);
    };

    const showFilters = () => {
        setCollapsed(!collapsed);
    }

    const cleanFields = () => {
        setLoading(true);
        reset();
        setBenefit(null);

        const dataRequest = {
            promotion: {id: promotion?.id},
            benefit: {id: null}
        };

        refreshDataList(dataRequest);
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onBenefitChange = (value) => {
        setBenefit(value);
    }

    // ----------------------------------------------
    //            TABLE BUTTONS
    // ----------------------------------------------
    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        promotionBenefitService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);

                const dataRequest = {
                    promotion: {id: promotion?.id},
                    benefit: {id: null}
                };

                refreshDataList(dataRequest);

                if (utilHelper.hasAssociateRecords()) {
                    showToastCustom(error, deleteErrorMsg, true);
                    utilHelper.restartAssociateRecords();
                } else {
                    showToastCustom(warning, deleteMsg, true);
                }
            });
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'code',
        text: 'Codigo de beneficio',
        sort: true
    }, {
        dataField: 'showOrder',
        text: 'Orden',
        sort: true
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '100px'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <CardBody className="">
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Select name="benefit"
                                                value={benefit}
                                                options={benefitOptions}
                                                components={animatedComponents}
                                                placeholder="Selecciona un beneficio"
                                                isSearchable={true}
                                                isClearable={true}
                                                onChange={onBenefitChange}/>
                                    </FormGroup>
                                </Col>
                                <Col md="8">
                                    <div className="float-right">
                                        <ButtonSearch/>
                                        <ButtonClean onClick={() => cleanFields()}/>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Form>
                </Collapse>
                <CardBody className="">
                    {loading && showLoader()}
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listItems}
                        columns={columns}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
});
